import PropTypes from 'prop-types';

export const addonPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  description: PropTypes.string,
  availableQuantity: PropTypes.number,
  price: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
  imageUrl: PropTypes.string,
  includeInPayment: PropTypes.bool, // Whether this addon is included in deposit / full payments or not
  showLearnMore: PropTypes.bool, // Whether to show the learn more screen
  allImages: PropTypes.arrayOf(
    PropTypes.shape({
      active: PropTypes.bool,
      imageId: PropTypes.number,
      imageUrl: PropTypes.string,
      main: PropTypes.bool,
    }),
  ),
  extraContent: PropTypes.shape({
    id: PropTypes.number,
    optionId: PropTypes.number,
    optionalTitle: PropTypes.string,
    featureShortText: PropTypes.string,
    featureLongText: PropTypes.string,
    infoButtonLabel: PropTypes.string, // Learn More by default
    showInfoButton: PropTypes.number, // supposed to be a bool
    createdAt: PropTypes.string,
  }),
  checkinDetails: PropTypes.shape({
    checkinTime: PropTypes.string,
    checkoutTime: PropTypes.string,
    showCheckoutTime: false,
  }),
});

export const addonGroupPropTypes = PropTypes.shape({
  id: PropTypes.number,
  name: PropTypes.string,
  compulsory: PropTypes.bool,
  matchGuests: PropTypes.bool, // If true, the amount of selections must match the guest amount
  addons: PropTypes.arrayOf(addonPropTypes),
  headingLabel: PropTypes.string,
  showBeforeDetails: PropTypes.bool,
  showAccommodationStepPrice: PropTypes.bool,
  isAccommodation: PropTypes.bool, // cool
});

export const experiencePropTypes = PropTypes.shape({
  id: PropTypes.number, // TODO check IDs are numbers on the ECB API
  name: PropTypes.string,
  description: PropTypes.string, // aka summary
  experienceType: PropTypes.string, // Event, Banquet, Accommodation, ?
  experienceTypeSettings: PropTypes.shape({
    accommodation: PropTypes.number, // TODO Should be bool but backend returns 0/1
    dining: PropTypes.number, // TODO Should be bool but backend returns 0/1
    event: PropTypes.number, // TODO Should be bool but backend returns 0/1
    menu: PropTypes.number, // TODO Should be bool but backend returns 0/1
  }),
  addonGroups: PropTypes.arrayOf(addonGroupPropTypes),
  available: PropTypes.number, // How many are left
  fullDescription: PropTypes.string, // unused
  imageUrl: PropTypes.string,
  minGuests: PropTypes.number, // 0 min and 0 max means no validation on size
  maxGuests: PropTypes.number,
  multiplier: PropTypes.string, // per_group or per_person
  paymentSettingId: PropTypes.number, // The payment setting to use on the cc screen. If null, then no payment taken (overrides default restaurant settings)
  price: PropTypes.number, // The cost
  primaryOptionId: PropTypes.number,
  soldAlone: PropTypes.bool, // Whether this experience can be used with others or not
  showAvailableNumber: PropTypes.bool, // Whether we show the amount available on the card
  selectionShowTotalPrice: PropTypes.bool,
  termsAndConditions: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      dailyViewDisplay: PropTypes.string,
      termsConditions: PropTypes.string,
    }),
  ),
});

export const experiencesPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(experiencePropTypes),
  forceAccommodationSelection: PropTypes.bool.isRequired,
  requireExperienceSelection: PropTypes.bool.isRequired,
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool,
});

export const addonGroupsPropTypes = PropTypes.shape({
  data: PropTypes.arrayOf(addonGroupPropTypes),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool,
});

export const accommodationPropTypes = PropTypes.shape({
  data: PropTypes.shape({
    selectableRooms: PropTypes.arrayOf(PropTypes.shape({})),
  }),
  error: PropTypes.string,
  pending: PropTypes.bool,
  success: PropTypes.bool,
});
